const ENGAGE_BASE = '/dashboard/engage';

/** Relative paths for nested routes within /dashboard/engage/* */
export const engageNestedRoutes = {
  AUTOMATIONS_EDIT: 'automations/edit/:automation-id',
  SEGMENTS_EDIT: 'segments/edit/:canonicalVersionId',
} as const;

export const appRoutes = {
  ENGAGE_SETUP: ENGAGE_BASE,
  ENGAGE_AUTOMATIONS: `${ENGAGE_BASE}/automations`,
  ENGAGE_AUTOMATIONS_EDIT: `${ENGAGE_BASE}/${engageNestedRoutes.AUTOMATIONS_EDIT}`,
  ENGAGE_SEGMENTS: `${ENGAGE_BASE}/segments`,
  ENGAGE_SEGMENTS_EDIT: `${ENGAGE_BASE}/${engageNestedRoutes.SEGMENTS_EDIT}`,
} as const;

/** Build navigation path by replacing :automation-id param */
export const buildAutomationEditPath = (automationId: string): string =>
  appRoutes.ENGAGE_AUTOMATIONS_EDIT.replace(':automation-id', automationId);

/** Build navigation path by replacing :canonicalVersionId param */
export const buildSegmentEditPath = (canonicalVersionId: string): string =>
  appRoutes.ENGAGE_SEGMENTS_EDIT.replace(
    ':canonicalVersionId',
    canonicalVersionId,
  );
